<template>
    <div>
        <div class="head">
            <img :src="bannerS" class="img100" alt="">

            <!-- <div class="head_banner_box">
                <div class="widthBox">
                    <div class="head_banner">
                        <img v-if="web_info.web_info" :src="web_info.web_info.web_header_logo_url" class="img100" alt="">
                        <div class="title mb_40">{{$t("BUILD YOUR TOMORROW,TODAY")}}</div>
                        <a class="btn radius-4" target="_blank" href="http://phromonglobal.com">{{ $t("Join now") }}</a>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="widthBox">
            <el-row :gutter="10" class="acea-row mt_120">
                <el-col :span="12" :xs="24" class="hidden-sm-and-up">
                    <img class="img100 radius-8" src="@/assets/img_1.png" alt="">
                </el-col>
                <el-col :span="12" :xs="24">
                    <h2 class="txt mb_4 mt_20">{{ $t("SHARING WHAT YOU LOVE") }} </h2>
                    <h1 class="title txt_left mb_20">{{ $t("HAS SOME SERIOUS PERKS") }} </h1>
                    <div class="info f-20 mb_12">{{ $t("Excluusive Youth-Enhancement Products") }}</div>
                    <ul class="mb_20">
                        <li class="mb_8">{{ $t("Perfectly positioned in a booming sectorProducts people are ravina about") }}</li>
                        <li class="mb_8">{{ $t("Products people are ravina about") }}</li>
                    </ul>

                    
                    <div class="info f-20 mb_12">{{ $t("Dedicated Support") }}</div>
                    <ul class="mb_20">
                        <li class="mb_8">{{ $t("Your own personal website") }}</li>
                        <li class="mb_8">{{ $t("Business tools & training 24/7") }}</li>
                        <li class="mb_8">{{ $t("Social media resources & your own business app") }}</li>
                    </ul>

                    
                    <div class="info f-20 mb_12">{{ $t("A Rewarding Lifestyle") }}</div>
                    <ul>
                        <li class="mb_8">{{ $t("Time, freedom & financial") }}</li>
                        <li class="mb_8">{{ $t("securityLuxury vacation with Lifestvle Rewards") }}</li>
                        <li class="mb_8">{{ $t("Lasting relationships with people all around the world") }}</li>
                        <li class="mb_8">{{ $t("Events & celebrations") }}</li>
                        <li class="mb_8">{{ $t("The chance to give back") }}</li>
                        <li class="mb_8">{{ $t("For more details, check out the Financial Rewards Plan") }}</li>
                    </ul>
                </el-col>
                <el-col :span="12" :xs="24" class="hidden-xs-only">
                    <img class="img100 radius-8" src="@/assets/img_1.png" alt="">
                </el-col>
            </el-row>
            <el-row :gutter="10" class="acea-row mt_80 row-between">
                <el-col :span="18" :xs="24">
                    <video  controls :src="video" class="img100 radius-8"></video>
                </el-col>
            </el-row>
        </div>

        <div class="mt_80 widthBox mb_40">
            <h2 class="txt mb_4">{{ $t("FINANCIA") }} </h2>
            <h1 class="title txt_left mb_16">{{ $t("REWARDS") }}</h1>
            <p class="txt f-20 mb_20">{{ $t("You set your own goals on your own schedule.") }}</p>
            <p class="info3 f-20 ">{{ $t("We give you exclusive products, expert training resources and pro marketing materials to build yourbusiness on your terms. Whether youire looking to earn some part-time income or grow your operationson our global platform, Jeunesse provides a lucrative business opportunity for all types of direct") }}</p>
        </div>
        <div class="bgf5 mb_40">
            <div class="widthBox pd_tb_40">
                <p class="info2 f-20 mb_24">{{ $t("The Jeunesse Financial Rewards plan is one of the most competitive compensation plans in theindustry.") }} </p>
                <p class="info2 f-20">{{ $t("Our Distributors are able to generate income in six diferent ways, earn luxury travel rewards and climb 15prestigious achievement ranks.") }} </p>
            </div>
        </div>
        <div class="widthBox footer">
            <div class="info3 f-20">{{ $t("Our Distributors are able to generate income in six diferent ways, earn luxury travel rewards and climb 15prestigious achievement ranks.") }} </div>
            <router-link class="btn cursor radius-4" to="/FinancialRewards">{{ $t("Learn more") }} </router-link>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    computed: {
        video() {
            return this.$store.state.video
        },
        bannerS() {
            return this.$store.state.bannerS
        },
        web_info(){
            return this.$store.state.common
        }
    },
    created() {
        this.get_info();
    },
    methods: {
        async get_info() {
            let res = await this.$api.get("api/Index/index", this.query);

        }
    }
}
</script>

<style lang="scss" scoped="scoped">
.footer {
    .btn {
        float: right;
        margin-top: 20px;
    }
}

.bgf5 {
    background: #f5f5f5;
}

.pd_tb_40 {
    padding-top: 40px;
    padding-bottom: 40px;
}

.mt_20 {
    margin-top: 20px;
}

.mb_40 {
    margin-bottom: 40px;
}

.mt_80 {
    margin-top: 80px;
}

.mb_4 {
    margin-bottom: 4px;
}

.mb_8 {
    margin-bottom: 8px;
}

.mb_12 {
    margin-bottom: 12px;
}

.mb_16 {
    margin-bottom: 16px;
}

.mb_20 {
    margin-bottom: 20px;
}

.mb_24 {
    margin-bottom: 24px;
}

.mt_120 {
    margin-top: 120px;
}

ul li {
    list-style: disc;
    color: #666666;
    font-size: 16px;
    position: relative;
    left: 16px;
}

.btn {
    padding: 12px 24px;
    font-size: 14px;
    color: #Fff;
    background: #B50900;
    display: inline-block;
}

.head {
    position: relative;
    width: 100%;
    height: 100%;
    .head_banner_box{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0%;
        left: 0;
        .widthBox{
            position: relative;
            height: 100%;
        }
    }
    .head_banner {
        position: absolute;
        top: 20%;
        right: 0;
        background: #Fff;
        border-radius: 8px;
        padding: 40px;
        width: 30%;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;

        .img100 {
            padding: 0 45px;
            box-sizing: border-box;
            margin-bottom: 20px;
        }

        .title {
            color: #000;
            width: 100%;
        }
    }
}

@media screen and(max-width:1000px) {
    .head_banner {
        top: 50% !important;
        left: 20px;
        box-sizing: border-box;
        padding: 20px !important;
        width: calc(100% - 40px) !important;
        box-shadow: 0px 5px 20px rgba($color: #000000, $alpha: 0.3);

        .img100 {
            padding: 0 180px !important;
        }

        div {
            width: 100%;
            padding: 0 180px !important;
        }
    }

    .mt_120 {
        margin-top: 250px;
    }
}

@media screen and(max-width:768px) {
    .head_banner {
        .img100 {
            padding: 0 15% !important;
        }

        div {
            width: 100%;
            padding: 0 15% !important;
            text-align: center;
        }
    }

    .txt {
        font-size: 14px !important;
    }

    .title {
        font-size: 20px !important;
    }

    .mb_4 {
        margin-bottom: 8px;
    }

    .mb_12 {
        margin-bottom: 16px;
    }

    .mt_80 {
        margin-top: 56px !important;
    }

    .f-20 {
        font-size: 14px;
    }

    .pd_tb_40 {
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .mb_24 {
        margin-bottom: 16px;
    }

    .mb_40 {
        margin-bottom: 20px;
    }

    .mt_120 {
        margin-top: 200px;
    }

    .footer {
        margin-bottom: 100px;
    }
}</style>